import computed from './attrs/computed'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import props from './attrs/props'
import data from './attrs/data'

export default {
    name: 'Order',
    computed,
    methods,
    mounted,
    props,
    data
}
